import { useEffect, useRef, useId } from 'react';
import { useTheme } from '@/contexts/ThemeContext';

interface CaseReportSubmittedDialogProps {
  isOpen: boolean;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export function CaseReportSubmittedDialog({
  isOpen,
  message,
  onConfirm,
  onCancel,
}: CaseReportSubmittedDialogProps) {
  const { theme } = useTheme();
  const confirmBtnRef = useRef<HTMLButtonElement>(null);
  const titleId = useId();

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('kstc-scroll-lock');
      requestAnimationFrame(() => {
        confirmBtnRef.current?.focus();
      });
    }
    return () => {
      document.body.classList.remove('kstc-scroll-lock');
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div data-kstc-modal className={`kstc-backdrop ${theme}`}>
      <div
        className="kstc-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
      >
        <div className="kstc-header">
          <h2 id={titleId} className="kstc-title">Case Report Submitted</h2>
        </div>
        <div className="kstc-body">
          <p className="kstc-message">{message}</p>
        </div>
        <div className="kstc-actions">
          <button
            className="kstc-btn kstc-btn--secondary"
            onClick={onCancel}
            type="button"
          >
            Cancel
          </button>
          <button
            ref={confirmBtnRef}
            className="kstc-btn kstc-btn--primary"
            onClick={onConfirm}
            type="button"
          >
            View Case Report
          </button>
        </div>
      </div>
    </div>
  );
}

(window as any).CaseReportSubmittedDialogReact = CaseReportSubmittedDialog;
